class AddToCartPanel extends Panel {
  constructor() {
    super();
    this.productHandle = document.querySelector('[data-product-handle]').dataset.productHandle;
    this.contentElement = this.querySelector('#product-add-to-cart-content');
    this.cartPanel = document.querySelector('cart-panel');
    this.localeSwitcher = this.querySelector('.locale-switchers');
    if (!this.localeSwitcher) return;
    this.localeButtons = this.localeSwitcher.querySelectorAll('button');
    this.localeButtons.forEach((localeButton) => {
      localeButton.addEventListener('click', this.handleLocaleSwitch.bind(this));
    });
  }

  handleLocaleSwitch(event) {
    this.usSizes = this.querySelectorAll('[data-us-size]');
    this.ukSizes = this.querySelectorAll('[data-uk-size]');
    this.ukOnlyVariants = this.querySelectorAll('[data-locale-us="false"]');
    const prevButton = this.querySelector(`.locale-switchers button.active`);
    prevButton.classList.remove('active');
    prevButton.setAttribute('aria-current', 'false');
    const currentButton = this.querySelector(
      `.locale-switchers button[data-locale="${event.currentTarget.dataset.locale}"]`,
    );
    currentButton.classList.add('active');
    currentButton.setAttribute('aria-current', 'true');
    if (event.currentTarget.dataset.locale == 'uk') {
      this.localeSwitcher.classList.add('uk-active');
      this.localeSwitcher.classList.remove('us-active');
      this.usSizes.forEach((usSize) => {
        usSize.classList.add('hidden');
      });
      this.ukSizes.forEach((ukSize) => {
        ukSize.classList.remove('hidden');
      });
      this.ukOnlyVariants.forEach((ukOnlyVariant) => {
        ukOnlyVariant.classList.remove('!hidden');
      });
    } else {
      this.localeSwitcher.classList.remove('uk-active');
      this.localeSwitcher.classList.add('us-active');
      this.usSizes.forEach((usSize) => {
        usSize.classList.remove('hidden');
      });
      this.ukSizes.forEach((ukSize) => {
        ukSize.classList.add('hidden');
      });

      this.ukOnlyVariants.forEach((ukOnlyVariant) => {
        ukOnlyVariant.classList.add('!hidden');
      });
    }
  }

  openCart() {
    const cartContent = document.querySelector('cart-panel');
    const cartItemCounts = document.querySelectorAll('[data-cart-item-count]');
    fetch(`/cart?section_id=dynamic-cart-content`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const details = html.querySelector('#cart');
        cartContent.querySelectorAll('[data-dynamic-cart-content]').forEach((x) => x.remove());
        cartContent.insertAdjacentHTML('beforeend', details.innerHTML);
        const countHtml = document.createElement('div');
        countHtml.innerHTML = text;
        const countDetails = countHtml.querySelector('#cart-item-count');
        cartItemCounts.forEach((cartItemCount) => {
          cartItemCount.textContent = countDetails.innerHTML;
        });
        panelManager.dispatch('OPEN_CART');
        // this.cartPanel.addScrollEvent();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      } else if (previousPanel) {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate();
      }
    });
  }
}
customElements.define('add-to-cart-panel', AddToCartPanel);
